<script setup>
import PanelLayout from "@/layouts/PanelLayout.vue";
import {onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import {getContext} from "@/services/context.js";
import {GetOrganisation} from "@/services/organisationService.js";
import {GetApp} from "@/services/appService.js";
import {GetPanel, GetHistory} from "@/services/panelsService.js";
import {formatDate} from "@/services/dateService.js";
import {Skeleton} from '@/components/ui/skeleton'

const route = useRoute();

const organisation = ref(null);
const app = ref(null);
const isLoading = ref(true);

const panel = ref(null);
const history = ref(null);
const token = ref(null);

onMounted(async () => {
  organisation.value = await GetOrganisation(getContext(route));
  app.value = await GetApp(getContext(route));
  panel.value = await GetPanel(getContext(route), route.params.panelId);
  history.value = await GetHistory(getContext(route));
  token.value = panel.value.token;

  isLoading.value = false;
});
</script>

<template>
  <PanelLayout :organisation="organisation" :app="app" :panel="panel" v-if="organisation && app && panel">
    <div class="w-full">
      <h2 class="text-lg font-semibold mb-2">
        History
      </h2>

      <div v-if="isLoading" class="flex items-center space-x-2">
        <Skeleton v-if="isLoading" class="w-1/3 h-12"/>
        <Skeleton v-if="isLoading" class="w-1/3 h-12"/>
        <Skeleton v-if="isLoading" class="w-1/3 h-12"/>
      </div>

      <div class="overflow-hidden" v-if="!isLoading">
        <table class="w-full table-fixed border-collapse border  border-gray-400 bg-white text-sm dark:border-gray-500 dark:bg-gray-800">
          <thead class="bg-gray-50 dark:bg-gray-700">
          <tr>
            <th class="w-1/2 border border-gray-300 p-4 text-left font-semibold text-gray-900 dark:border-gray-600 dark:text-gray-200">Date</th>
            <th class="w-1/2 border border-gray-300 p-4 text-left font-semibold text-gray-900 dark:border-gray-600 dark:text-gray-200">Action</th>
            <th class="w-1/2 border border-gray-300 p-4 text-left font-semibold text-gray-900 dark:border-gray-600 dark:text-gray-200">Comment</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in history" :key="index">
            <td class="border border-gray-300 p-4 text-gray-500 dark:border-gray-700 dark:text-gray-400">
              {{ formatDate(item.created) }}
            </td>
            <td class="border border-gray-300 p-4 text-gray-500 dark:border-gray-700 dark:text-gray-400">
              Update
            </td>
            <td class="border border-gray-300 p-4 text-gray-500 dark:border-gray-700 dark:text-gray-400">
              {{ item.changeComment }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </PanelLayout>
</template>

<style scoped>
</style>